import { pythonVmInstance } from "utils/AxiosInstances/RareboxPythonInstance";

const CHAT_BASE = "/api/relook/analytics-chat";

export const sendAnalyticsChatMessage = async ({ message, conversationId }) => {
	const payload = { message };
	if (conversationId) {
		payload.conversationId = conversationId;
	}
	const { data } = await pythonVmInstance.post(CHAT_BASE, payload);
	return data;
};

export const listAnalyticsConversations = async (limit = 50) => {
	const { data } = await pythonVmInstance.get(`${CHAT_BASE}/conversations`, {
		params: { limit },
	});
	return data;
};

export const getAnalyticsConversation = async (conversationId) => {
	const { data } = await pythonVmInstance.get(`${CHAT_BASE}/conversations/${conversationId}`);
	return data;
};
